export function getSearch(state) {
  return state.search;
}



// WEBPACK FOOTER //
// ./src/core/search/selectors.js